'use strict';

function getS3Key (url) {
  return encodeURIComponent(url);
}

module.exports = getS3Key;
